// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { Node } from 'react';
import Wrapper from './atoms/wrapper';
import Rating from './atoms/rating';
import ReviewLink from './atoms/reviewLink';
import TextualRating from './atoms/textualRating';
import {
  getAllReviewsLinkText,
  getBasedOn,
  getRating,
  getReviewCount,
  getReviews,
  getScore,
} from '../../store/componentSettings/selectors/reviewSettings';
import type { Rating as RatingType, ReviewProps } from './types';

type StateProps = {|
  basedOn: string,
  linkText: string,
  rating: RatingType,
  reviewCount: string,
  reviews: string,
  score: string,
|};

type StatelessProps = {|
  ...ReviewProps,
  children?: Node,
|};

type Props = {|
  ...StateProps,
  ...StatelessProps,
|};

const Review = ({
  basedOn,
  children,
  items,
  linkText,
  rating,
  reviewCount,
  reviews,
  score,
  template,
  title,
  url,
  use_list,
  variant,
  view,
  ...props
}: Props) => {
  let Component;

  const floatScore = parseFloat(score);
  const textualRating = rating[`rating_${Math.floor(floatScore)}`] || '';

  if (view === 'minimalistic') {
    Component = <TextualRating>{textualRating}</TextualRating>;
  } else {
    Component = (
      <ReviewLink
        url={url}
        basedOnText={`${basedOn} ${reviewCount} ${reviews}`}
        linkText={linkText}
        template={template}
        view={view}
      />
    );
  }

  return (
    <Wrapper variant={variant} template={template} {...props}>
      <Rating
        rating={floatScore}
        template={template}
        view={view}
      />
      {Component}
      {children && children}
    </Wrapper>
  );
};

Review.defaultProps = {
  children: null,
};

const mapStateToProps = (state): StateProps => ({
  linkText: getAllReviewsLinkText(state),
  reviews: getReviews(state),
  rating: getRating(state),
  basedOn: getBasedOn(state),
  score: getScore(state),
  reviewCount: getReviewCount(state),
});

export default connect<any, StatelessProps, StateProps, any, any, any>(mapStateToProps)(Review);
